import { CoreActionTypes, EnableMementoCheckAction } from '../types';

export const enableMementoCheckAction = (): EnableMementoCheckAction => ({
  type: CoreActionTypes.ENABLE_MEMENTO_CHECK,
});
